import type {FeatureCollection} from 'geojson';
import type {GeometryCollection, Topology} from 'topojson-specification';

const ANTARCTICA = '010';

let world: Promise<FeatureCollection | undefined> | null = null;

/**
 * World country outlines for the bubble maps: Natural Earth 1:50m (public domain) from the bundled world-atlas package,
 * split into their own chunk and loaded once, with the first map. Antarctica is left out: under Mercator it would
 * dominate a whole-world view. Resolves to undefined if the chunk cannot be loaded, so a map still draws its bubbles.
 */
export function loadWorldOutline(): Promise<FeatureCollection | undefined> {
    world ??= Promise.all([import('world-atlas/countries-50m.json'), import('topojson-client')])
        .then(([atlas, topo]) => {
            const topology = atlas.default as unknown as Topology<{countries: GeometryCollection}>;
            const countries = topo.feature(topology, topology.objects.countries) as FeatureCollection;
            return {...countries, features: countries.features.filter(f => f.id !== ANTARCTICA)};
        })
        .catch(() => {
            world = null; // try again with the next map
            return undefined;
        });
    return world;
}
